import type {LibraryParameterDefinitionContextItem} from 'procedures/parameter-library/LibraryParameterDefinitionsContext';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';

/**
 * Whether a library parameter definition can be recorded as a Reaction Condition: a numeric (float) definition
 * that has a unit type, since each condition stores a numeric value and a unit.
 */
export function isReactionConditionParameter({
  fieldType,
  unitTypeId,
}: {
  fieldType: FieldType;
  unitTypeId?: string | null;
}): boolean {
  return fieldType === FieldType.FLOAT && unitTypeId != null;
}

/** Limits library parameter definitions to those a Reaction Condition can record. */
export function filterReactionConditionParameterDefinitions(
  definitions: Array<LibraryParameterDefinitionContextItem>
): Array<LibraryParameterDefinitionContextItem> {
  return definitions.filter((definition) => isReactionConditionParameter(definition));
}
